export function startpage() {
  if (!document.querySelector('.page-Start')) {
    removeFooterTextFromNonStartPages();
    return;
  }

  removeFilterWrapper();
  buildHeroSection();
}

function removeFooterTextFromNonStartPages() {
  const footerText = document.getElementById('MainFooter_FooterText');
  if (footerText) {
    footerText.remove();
  }
}

function removeFilterWrapper() {
  const filterWrapper = document.getElementById('FilterWrapper');
  if (filterWrapper) {
    filterWrapper.style.display = 'none';
  }
}

function buildHeroSection() {
  const mainSearch = document.getElementById('MainSearch');
  if (!mainSearch) return;
  if (document.getElementById('StartpageHero')) return;

  const firstBanner = document.querySelector('#BannersetsView #Bannerset_START .bannerset-inner .banner');
  const footerText = document.getElementById('MainFooter_FooterText');
  if (!firstBanner && !footerText) return;

  const hero = document.createElement('div');
  hero.id = 'StartpageHero';
  hero.className = 'startpage-hero wl-added';

  if (firstBanner) {
    const bannerText = firstBanner.querySelector('.banner-inner-content .banner-text');
    const bannerImg = firstBanner.querySelector('.banner-img-wrapper img');

    const banner = document.createElement('div');
    banner.id = 'StartpageHeroBanner';
    banner.className = 'startpage-hero-banner';

    const hasText = bannerText && bannerText.innerHTML.trim() !== '';

    if (bannerImg) {
      const imgSrc = bannerImg.getAttribute('data-src') || bannerImg.getAttribute('src');
      if (imgSrc && !imgSrc.startsWith('data:')) {
        if (hasText) {
          banner.style.backgroundImage = `url('${imgSrc}')`;
        } else {
          const img = document.createElement('img');
          img.src = imgSrc;
          img.alt = bannerImg.getAttribute('alt') || '';
          img.className = 'startpage-hero-banner__img';
          banner.appendChild(img);
          banner.classList.add('startpage-hero-banner--image-only');
        }
      }
    }

    if (hasText) {
      banner.innerHTML = bannerText.innerHTML.trim();
    }

    hero.appendChild(banner);

    const original = document.getElementById('BannersetsView');
    if (original) original.style.display = 'none';
  }

  if (footerText) {
    footerText.classList.add('startpage-hero__footer-text', 'wl-added');
    hero.appendChild(footerText);
  }

  mainSearch.after(hero);
}
